// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.camp-module-section, .wellness-container, .other-activity-container{
    background: #f8ece4;
}
.typical-day-section,.team-container{
    background: #242E4C;
}
/* paper effect */
.paper {
    position: relative;
    width: 90%;
    max-width: auto;
    min-width: auto;
    height: 250px;
    margin: 0 auto;
    background: #fafafa;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,.3);
    overflow: hidden;
}
.paper:before {
    content: '';
    position: absolute;
    top: 0; bottom: 0; left: 0;
    width: 60px;
    background: radial-gradient(#575450 6px, transparent 7px) repeat-y;
    background-size: 30px 30px;
    border-right: 3px solid #D44147;
    box-sizing: border-box;
}

.paper-content {
    position: absolute;
    top: 30px; right: 0; bottom: 30px; left: 60px;
    background: linear-gradient(transparent, transparent 28px, #91D1D3 28px);
    background-size: 30px 30px;
}

.paper-content textarea {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    line-height: 30px;
    padding: 0 10px;
    border: 0;
    outline: 0;
    background: transparent;
    color: #000;
    font-family: 'Handlee', cursive;
    font-weight: bold;
    font-size: 16px;
    box-sizing: border-box;
    z-index: 1;
}
/* Base size for h1 */
.about__h1 {
    font-size: 3rem; /* Default for larger screens */
}

/* Adjust for tablets */
@media (max-width: 768px) {
    .about__h1 {
        font-size: 2rem;
    }
}

/* Adjust for mobile devices */
@media (max-width: 480px) {
    .about__h1 {
        font-size: 1.7rem;
    }
}

/* Base size for h2 */
.about__h2 {
    font-size: 2rem; /* Default for larger screens */
}

/* Adjust for tablets */
@media (max-width: 768px) {
    .about__h2 {
        font-size: 1.75rem;
    }
}

/* Adjust for mobile devices */
@media (max-width: 480px) {
    .about__h2 {
        font-size: 1.5rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/spectator/CampLife.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,eAAe;IACf,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM,EAAE,SAAS,EAAE,OAAO;IAC1B,WAAW;IACX,kEAAkE;IAClE,0BAA0B;IAC1B,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS,EAAE,QAAQ,EAAE,YAAY,EAAE,UAAU;IAC7C,wEAAwE;IACxE,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,WAAW;IACX,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,UAAU;AACd;AACA,qBAAqB;AACrB;IACI,eAAe,EAAE,+BAA+B;AACpD;;AAEA,uBAAuB;AACvB;IACI;QACI,eAAe;IACnB;AACJ;;AAEA,8BAA8B;AAC9B;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA,qBAAqB;AACrB;IACI,eAAe,EAAE,+BAA+B;AACpD;;AAEA,uBAAuB;AACvB;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA,8BAA8B;AAC9B;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".camp-module-section, .wellness-container, .other-activity-container{\n    background: #f8ece4;\n}\n.typical-day-section,.team-container{\n    background: #242E4C;\n}\n/* paper effect */\n.paper {\n    position: relative;\n    width: 90%;\n    max-width: auto;\n    min-width: auto;\n    height: 250px;\n    margin: 0 auto;\n    background: #fafafa;\n    border-radius: 10px;\n    box-shadow: 0 2px 8px rgba(0,0,0,.3);\n    overflow: hidden;\n}\n.paper:before {\n    content: '';\n    position: absolute;\n    top: 0; bottom: 0; left: 0;\n    width: 60px;\n    background: radial-gradient(#575450 6px, transparent 7px) repeat-y;\n    background-size: 30px 30px;\n    border-right: 3px solid #D44147;\n    box-sizing: border-box;\n}\n\n.paper-content {\n    position: absolute;\n    top: 30px; right: 0; bottom: 30px; left: 60px;\n    background: linear-gradient(transparent, transparent 28px, #91D1D3 28px);\n    background-size: 30px 30px;\n}\n\n.paper-content textarea {\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    max-height: 100%;\n    line-height: 30px;\n    padding: 0 10px;\n    border: 0;\n    outline: 0;\n    background: transparent;\n    color: #000;\n    font-family: 'Handlee', cursive;\n    font-weight: bold;\n    font-size: 16px;\n    box-sizing: border-box;\n    z-index: 1;\n}\n/* Base size for h1 */\n.about__h1 {\n    font-size: 3rem; /* Default for larger screens */\n}\n\n/* Adjust for tablets */\n@media (max-width: 768px) {\n    .about__h1 {\n        font-size: 2rem;\n    }\n}\n\n/* Adjust for mobile devices */\n@media (max-width: 480px) {\n    .about__h1 {\n        font-size: 1.7rem;\n    }\n}\n\n/* Base size for h2 */\n.about__h2 {\n    font-size: 2rem; /* Default for larger screens */\n}\n\n/* Adjust for tablets */\n@media (max-width: 768px) {\n    .about__h2 {\n        font-size: 1.75rem;\n    }\n}\n\n/* Adjust for mobile devices */\n@media (max-width: 480px) {\n    .about__h2 {\n        font-size: 1.5rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
